export const GA_MEASUREMENT_ID = "G-SCF4H7V13J";

export const GA4_EVENT_PAGE_VIEW = "page_view";
